import React, { useState } from 'react';
import classnames from 'classnames';
import { Waypoint } from 'react-waypoint';
import LoadingIndicator from '../../LoadingIndicator';
import { LoveMeter } from '../../LoveMeter';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import Sidebar from '../../Sidebar';
import Details from '../../DeviationViews/Details';
import LiteratureContent from '../../LiteratureContent';
import Comments from '../_partials/Comments';
import LoveSuggestionPanel from '../_partials/LoveSuggestionPanel';
import { getDeviationType } from '../../DeviationViews/_helpers';
import PanelPopup from '../../DeviationPage/_partials/PanelPopup';
import { isExtendedDeviationFullyLoaded } from '../redux/helpers';
import { DeviationTypes } from '../../types/deviation';
import s from './MobileDeviationPage.scss';
var MobileDeviationPage = function (_a) {
    var deviation = _a.deviation;
    var _b = useState(false), isSidebarVisible = _b[0], setSidebarVisible = _b[1];
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    var isLiterature = getDeviationType(deviation) === 'literature';
    var isJournal = getDeviationType(deviation) === DeviationTypes.JOURNAL;
    return (React.createElement("div", { className: s['root'] },
        React.createElement(LoveMeter, { itemId: deviation.deviationId, initialData: { loveScore: deviation.loveScore }, supportsRecommendations: true },
            React.createElement(ArtStage, { className: classnames(s['stage-content'], isJournal && s['journal-stage-content']), deviation: deviation }),
            React.createElement(ActionBar, { deviation: deviation }),
            isLiterature && (React.createElement("div", { className: s['lit-content'] },
                React.createElement(LiteratureContent, { deviation: deviation })))),
        React.createElement(PanelPopup, { deviation: deviation, actionBarType: "primary", className: s['large-popover-uplifted'] }),
        React.createElement(LoveSuggestionPanel, { deviationId: deviation.deviationId }),
        React.createElement(Details, { contentClassName: s['details'], deviation: deviation }),
        isExtendedLoaded && (React.createElement(React.Fragment, null,
            React.createElement(Comments, { deviation: deviation, className: s['comments'] }),
            React.createElement(Waypoint, { onEnter: function () { return setSidebarVisible(true); }, onLeave: function () { return setSidebarVisible(false); }, bottomOffset: -200 },
                React.createElement("div", { className: s['sidebar'] },
                    !isSidebarVisible && (React.createElement(LoadingIndicator, { className: s['lloader'], view: "llama" })),
                    isSidebarVisible && React.createElement(Sidebar, { deviation: deviation }))))),
        !isExtendedLoaded && (React.createElement(LoadingIndicator, { className: s['lloader'], view: "llama" }))));
};
MobileDeviationPage.displayName = 'MobileDeviationPage';
export default MobileDeviationPage;
//# sourceMappingURL=MobileDeviationPage.js.map